const basePublicPath = '/p'
const pages = {
  home: '/',
  performance: '/performance',
  wallet: '/wallet',
  profile: '/profile',
  registration: '/registration',
  onboarding: '/onboarding',
  setting: '/setting',
  topProduct: '/top-product',
  topSellingCategoryDetail: '/top-selling-category/:id',
  socialMedia: '/social-media',
  tagLink: '/tag-link',
  tagLinkPerformance: '/tag-link-performance',
  socialMediaLanding: basePublicPath + '/social-media/:type',
  socialMediaLandingApp: basePublicPath + '/social-media/:type/app',
  mission: basePublicPath + '/mission',
  missionDetail: basePublicPath + '/mission/:id',
  deal: '/member/poin-rewards',
  coupon: '/member/coupon',
  bonusCommissionSeller: '/bonus-commission-seller',
  topSellingCategory: '/top-selling-category',
  login: '/login',
  info: basePublicPath + '/info',
  notFound: '/:path(.*)*'
}

const app = {
  default: {
    locale: 'id'
  },
  routerName: {
    home: 'HomePage',
    performance: 'PerformancePage',
    profile: 'ProfilePage',
    registration: 'RegistrationPage',
    onboarding: 'OnboardingPage',
    wallet: 'WalletPage',
    setting: 'SettingPage',
    topProduct: 'TopProductPage',
    topSellingCategory: 'TopSellingCategoryPage',
    topSellingCategoryDetail: 'TopSellingCategoryDetailPage',
    socialMedia: 'SocialMediaPage',
    tagLink: 'TagLinkPage',
    tagLinkPerformance: 'TagLinkPerformancePage',
    socialMediaLanding: 'SocialMediaLandingPage',
    socialMediaLandingApp: 'SocialMediaLandingAppPage',
    mission: 'MissionPage',
    missionDetail: 'MissionDetailPage',
    bonusCommissionSeller: 'BonusCommissionSellerPage',
    info: 'InfoPage',
    notFound: 'NotFound'
  },
  tracker: {
    originScreen: {
      registration: 'affiliate-onboard',
      home: 'affiliate-home',
      performance: 'affiliate-performance',
      wallet: 'affiliate-wallet',
      profile: 'affiliate-kyc',
      setting: 'affiliate-setting',
      topProduct: 'affiliate-product-performance',
      missionList: 'affiliate-mission-list',
      missionDetail: 'affiliate-mission-detail',
      bonusCommissionSeller: 'affiliate-seller-bonus-commission',
      topSellingCategory: 'affiliate-best-selling-product',
      tagLink: 'affiliate-tag-link',
      tagLinkPerformance: 'affiliate-tag-link-performance'
    },
    home: 'home',
    performance: 'performance',
    wallet: 'wallet',
    setting: 'setting'
  },
  publicPath: '/p/',
  localStorage: {
    blibliTiketAffiliateFeature: 'blibli_tiket_affiliate_feature',
    blibliTiketOriginSource: 'blibli_tiket_origin_source'
  },
  hiddenMenuPages: [
    pages.registration,
    pages.topProduct,
    pages.socialMedia,
    pages.tagLink,
    pages.tagLinkPerformance,
    pages.onboarding,
    pages.info,
    pages.topSellingCategory
  ],
  hiddenMenuRegex: [
    `^${pages.socialMedia}/.*`,
    `^${pages.socialMediaLanding.replace('/:type', '')}/.*`,
    `^${pages.mission}/.*`,
    `^${pages.topSellingCategoryDetail.replace('/:id', '')}/.*`,
  ].map(pattern => new RegExp(pattern)),
  hiddenDesktopBannerRegex: [
    `^${pages.mission}.*`,
    `^${pages.info}$`
  ].map(pattern => new RegExp(pattern)),
  tenantIds: ['BLIBLI', 'TIKET']
}

const baseApi = '/api'
const basePublicApi = '/api/public'
const api = {
  auth: {
    refreshToken: `${baseApi}/auth/refresh`
  },
  config: {
    getRecommendationTabs: {
      tiket: `${baseApi}/config/tiket-product-recommendation-categories/value`,
      blibli: `${baseApi}/config/blibli-product-recommendation-categories/value`
    },
    getHomepageBanners: {
      tiket: `${baseApi}/config/tiket-homepage-banners/value`,
      blibli: `${baseApi}/config/blibli-homepage-banners/value`
    },
    getTestimonies: `${baseApi}/config/uap-testimonies/value`,
    getFaqList: `${baseApi}/config/uap-faq-list/value`,
    getTnc: `${baseApi}/config/uap-tnc/value`,
    getPrivacyPolicy: `${baseApi}/config/uap-privacy-policy/value`
  },
  productPerformance: {
    getTopSku: `${baseApi}/member/product-performance`,
    getTopMerchants: `${baseApi}/member/seller-performance`
  },
  productRecommendation: {
    findAll: {
      tiket: `${baseApi}/TIKET/product-recommendation`,
      blibli: `${baseApi}/BLIBLI/product-recommendation`
    },
    getProductRecommendationsByProductSku: (productSku) => `${baseApi}/BLIBLI/product-recommendation/ps--${productSku}`
  },
  productSummary: {
    getProductSummary: (productSku) => `${baseApi}/product/ps--${productSku}/_summary`
  },
  statistic: {
    summaryStatistic: `${baseApi}/member/statistic`
  },
  bank: {
    getBankList: `${baseApi}/bank`
  },
  member: {
    createMember: `${baseApi}/member`,
    getMember: `${baseApi}/member`,
    markOnboardingCompleted: `${baseApi}/member/onboarding/completed`
  },
  socialMedia: {
    getSocialMedia: `${baseApi}/member/social-media`,
    generateOauth: (socialMediaType) => `${baseApi}/member/social-media/${socialMediaType}/oauth`,
    getCache: (socialMediaType) => `${baseApi}/member/social-media/${socialMediaType}/oauth`,
    youtube: {
      bind: `${baseApi}/member/social-media/youtube`
    },
    instagram: {
      handleLogin: `${baseApi}/member/social-media/instagram`
    },
    facebook: {
      getPageList: `${baseApi}/member/social-media/facebook/page`,
      bind: `${baseApi}/member/social-media/facebook`
    },
    tiktok: {
      bind: `${baseApi}/member/social-media/tiktok`
    },
    twitter: {
      bind: `${baseApi}/member/social-media/twitter`
    },
    unbindSocialMedia: (socialMediaType) => `${baseApi}/member/social-media/${socialMediaType}`
  },
  tagLink: {
    getTagLinks: `${baseApi}/link-tags`,
    createTagLink: `${baseApi}/link-tags`,
    deleteTagLinks: `${baseApi}/link-tags`,
    getTagLinkPerformance: `${baseApi}/member/tag-performance`
  },
  mission: {
    getMission: `${baseApi}/quest/quests`,
    getMissionDetail: (id) => `${baseApi}/quest/quests/${id}`
  },
  kyc: {
    getProfile: `${baseApi}/member/kyc?skipNikImage=true`,
    getKycStatus: `${baseApi}/member/kyc-status`,
    getKtpImage: `${baseApi}/member/kyc/identity-card/ktp`,
    insertKyc: `${baseApi}/member/kyc`,
    validateKtpImage: `${baseApi}/member/ocr`
  },
  order: {
    getOrders: `${baseApi}/member/order`,
    getOrderDetail: (id) => `${baseApi}/member/order/${id}/item`
  },
  wallet: {
    getMemberBalance: `${baseApi}/member/wallet`,
    getMemberTransactionHistory: `${baseApi}/member/transaction`,
    getMemberTransactionHistoryDetail: (id) => `${baseApi}/member/transaction/${id}`
  },
  common: {
    contentAffiliate: `${baseApi}/config/unified-affiliate-configs/value`
  },
  category: {
    getList: `${baseApi}/member/category-filter`
  },
  memberBank: {
    updateMemberBankAccount: `${baseApi}/member/bank-account`
  },
  seller: {
    getFeaturedSeller: `${baseApi}/featured-seller`,
    getSellerCampaign: `${baseApi}/seller-campaign`,
    getCategoryFilter: `${baseApi}/seller-campaign/category-filter`
  },
  commission: {
    getCommissionRules: `${basePublicApi}/commission`
  },
  topSellingCategory: {
    getTopSellingCategories: `${baseApi}/top-selling-categories`,
    getTopSellingCategoryById: (id) => `${baseApi}/top-selling-categories/${id}`,
    getProductListByC3: (categoryC3Code) => `${baseApi}/top-selling-categories/products/${categoryC3Code}`
  }
}

const share = {
  param: 'share_link=1',
  campaign: 'Affiliate Share',
  pageType: 'PRODUCT_DETAIL',
  platform: 'Web',
  source: 'affiliates',
  medium: 'Share'
}

const growthbook = {
  carouselSeller: 'growth.affiliate.carousel-seller'
}

export {
  api,
  app,
  growthbook,
  pages,
  share
}
